// extracted by mini-css-extract-plugin
export default {"testSearch":"jGlz_AP78tad511ebH1gG","text-map":"_326FHiQLHzYx5vkLKAOmlc","col-lg-8":"AD7YuZpEwGrKm8uC8NQ04","col-lg-4":"_22i9-uJ5TVyjYniHFOhCLJ","button":"_1inLPOnFyJ48T22TEOjbdw"};